
import React from 'react';
// import ReactDOM from 'react-dom';
import { render } from 'react-snapshot';
import App from './components/App/App';
// import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/style.module.scss';

import * as serviceWorker from './serviceWorker';

require('es6-promise').polyfill();
render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.register();
 